<ng-container
  #chartRef

  chartBinding

  chartTimeframeController
  [chartTimeframeSelector]="tfs.timeframe$"
  [timesframes]="'Timeframes' | element | async | dataToTimeframes"

  timeframePreselection
  [timeframeSelector]="tfs"

  provideElements
  [documentId]="documentId"
  [reportIndex]="reportIndex"
  [funds]="this.selectedFund.get()">

  <div class="value-dev-header">
    <div>
      <div class="sd-headline sd-headline--size-xl">Wertentwicklung</div>
      <div class="sd-paragraph sd-leadtext--size-lg">
        {{ VALUE_ELEMENT | element | async | elementContentString }}
      </div>
    </div>

    <wct-time-frame-selection #tfs [activeButtons]="'Timeframes' | element | async | dataToTimeframes" />
  </div>

  <div class="value-dev-body">
    <wct-element-host
      class="stockgraph stockgraph-no-main-lines chart"
      [options]="chartOptions"
      [element]="('Wertentwicklung' | element | async) ?? ('Wertentwicklung_BMK' | element | async)"
      [hideIfNoElement]="false"

      [class.wct-loading-fade-children]="chartDocuments.loading()"

      wctLoadingIndicator
      [apiCallDisplayErrorToast]="false"
      [apiCallAdditionalLoading]="chartDocuments.loading" />

    <div class="table">
      <div class="sd-headline sd-headline--size-xl">Kennzahlen</div>
      <wct-element-host
        #tableRef

        [options]="tableOptions"
        [element]="TABLE_ELEMENT | element | async"
        [hideIfNoElement]="false"

        [class.wct-loading-fade-children]="tableDocument.loading()"

        provideElements
        [documentId]="documentId"
        [reportIndex]="reportIndex"
        [elements]="[TABLE_ELEMENT]"
        [funds]="this.selectedFund.get()"
        [parameters]="tfs.timeframe$ | async | tableParameters"

        wctLoadingIndicator
        [apiCallDisplayErrorToast]="false"
        [apiCallAdditionalLoading]="tableDocument.loading" />
    </div>
  </div>
</ng-container>
